import { createDemoApp } from '@fluentui/react-docsite-components';
import { AppDefinition } from './AppDefinition';
import { GettingStartedPage } from './GettingStartedPage';

createDemoApp(AppDefinition, GettingStartedPage);
